<template>
  <b-form-group>
    <b-form-checkbox-group
      v-model="selectedAttributes"
      class="row"
      name="Electrical"
      buttons
      @input="attributesSelection"
    >
      <b-col
        v-for="(subGroup, index) in groupedAttributesNames"
        :key="`${subGroup.name}${index}`"
        md="auto"
      >
        <p
          v-if="subGroup.series.length && selectedChart === 'ElectricalFiltration'"
          class="visnet-events__filters-type"
        >
          {{ subGroup.name }}:
        </p>
        <b-form-checkbox
          v-for="(attribute, attributeIndex) in subGroup.series"
          :key="attributeIndex"
          :value="attribute.name"
          class="custom-check-button"
          button-variant="outline"
        >
          {{ attribute.mappedName }}
        </b-form-checkbox>
      </b-col>
    </b-form-checkbox-group>
  </b-form-group>
</template>

<script>
import { mapState } from 'vuex';
import find from 'lodash/find';
import {
  DEFAULT_FILTRATION_VALUE,
  ELECTRICAL_ATTRIBUTES_SUBGROUPS,
  GROUPS
} from '@/components/shared/visnet-hubs-common-consts';

export default {
  name: 'AttributesButtons',
  props: {
    attributes: Array,
    selectedChart: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedAttributes: []
    };
  },
  computed: {
    ...mapState({
      electricalFiltration: state => state.electricalData.filtration,
      powerQualityFiltration: state => state.powerQualityData.filtration
    }),
    isElectrical() {
      return this.selectedChart === 'ElectricalFiltration';
    },
    defaultValue() {
      const { ELECTRICAL, POWER_QUALITY } = DEFAULT_FILTRATION_VALUE;

      return this.isElectrical ? ELECTRICAL : POWER_QUALITY;
    },
    attributesNames() {
      if (this.attributes.length) {
        return this.attributes.map(attribute => ({
          mappedName: this.selectedChartNameMappings[attribute],
          name: attribute
        }));
      }
      return {};
    },
    selectedChartNameMappings() {
      return this.isElectrical ? GROUPS.ELECTRICAL : GROUPS.POWER_QUALITY;
    },
    selectedChartStoreMappings() {
      return this.isElectrical ? this.electricalFiltration : this.powerQualityFiltration;
    },
    selectedChartStoreMappingNames() {
      return this.isElectrical ? 'electricalData' : 'powerQualityData';
    },
    groupedAttributesNames() {
      const groupedObject = {};

      if (!this.isElectrical) {
        return { powerQuality: { series: this.attributesNames } };
      }

      Object.keys(ELECTRICAL_ATTRIBUTES_SUBGROUPS).forEach(subGroup => {
        const groupName = ELECTRICAL_ATTRIBUTES_SUBGROUPS[subGroup].name;

        groupedObject[groupName] = {
          name: groupName,
          series: []
        };
      });

      this.attributesNames.forEach(attribute => {
        const matchingSubgroup = find(ELECTRICAL_ATTRIBUTES_SUBGROUPS, subGroup =>
          subGroup.series.includes(attribute.name)
        );

        groupedObject[matchingSubgroup.name].series.push(attribute);
      });
      return groupedObject;
    }
  },
  mounted() {
    const mergedAttributes = [
      ...new Set([
        this.defaultValue,
        ...this.selectedAttributes,
        ...this.selectedChartStoreMappings
      ])
    ];

    this.selectedAttributes = mergedAttributes;

    this.attributesSelection(mergedAttributes);
  },
  methods: {
    attributesSelection(attributesSelected) {
      this.$store.commit(
        `${this.selectedChartStoreMappingNames}/setActiveFiltration`,
        attributesSelected
      );
    }
  }
};
</script>
